<template>
    <v-navigation-drawer absolute fixed temporary v-model="$icsilab.store.state.drawerMenu">
        <div style="display: flex; align-items: center;margin: 10px">
            <img v-if="$icsilab.getHeader().imageSrc" :src="$icsilab.getUrlImage($icsilab.getHeader().imageSrc)" alt="" height="50px"/>
            <v-list-item-title style="width: 100%;text-align: center;font-size: 1.15rem">{{$icsilab.getHeader().titre}}</v-list-item-title>
        </div>
        <v-divider style="margin: 5px"></v-divider>
        <v-list nav dense>
            <v-list-item-group>
                <template v-for="(item,index) in $store.state.datas.pages">
                    <v-list-item v-if="item.is_menu === 1" :key="index" @click="f_route(item)" style="justify-content: center">
                        <v-list-item-icon v-if="item.icon || item.image_src" style="margin-right: 15px">
                            <v-icon v-if="item.icon" color="#09203F">{{item.icon}}</v-icon>
                            <v-img v-if="item.image_src"  :src="$icsilab.getUrlImage(item.image_src)" contain></v-img>
                        </v-list-item-icon>
                        <v-list-item-title v-if="item.label" :class="($route.name === item.route) ? 'active' : ''">{{item.label}}</v-list-item-title>
                    </v-list-item>
                </template>
            </v-list-item-group>
        </v-list>
    </v-navigation-drawer>
</template>
<script>
    export default {
        name: "FxMenu",
        methods: {
            f_route(item) {
                this.$icsilab.goToPage(item.route)
            }
        }
    }
</script>
<style scoped>
    .active {
        color: #F54845
    }
</style>
